import * as jsxRuntime from "/codebuild/output/src3533864839/src/git-codecommit.eu-central-1.amazonaws.com/v1/repos/hgskey-amplify-identity-broker/node_modules/react/jsx-runtime.js"
export const jsx = jsxRuntime.jsx
export const jsxs = jsxRuntime.jsxs
export const Fragment = jsxRuntime.Fragment